import store from '@/store';
import { keys, values } from 'lodash';

function str_ireplace(search: any, replace: any, subject: any, countObj?: any): string {
    let i = 0;
    let j = 0;
    let temp: any = '';
    let repl: any = '';
    let sl = 0;
    let fl = 0;
    let f: any = '';
    let r: any = '';
    let s: any = '';
    let ra: any = '';
    let otemp: any = '';
    let oi: any = '';
    let ofjl: any = '';
    let os = subject;
    const osa = Object.prototype.toString.call(os) === '[object Array]';
    // var sa = ''
    if (typeof (search) === 'object') {
      temp = search;
      search = [];
      for (i = 0; i < temp.length; i += 1) {
        search[i] = temp[i].toLowerCase();
      }
    } else {
      search = search.toLowerCase();
    }
    if (typeof (subject) === 'object') {
      temp = subject;
      subject = [];
      for (i = 0; i < temp.length; i += 1) {
        subject[i] = temp[i].toLowerCase();
      }
    } else {
      subject = subject.toLowerCase();
    }
    if (typeof (search) === 'object' && typeof (replace) === 'string') {
      temp = replace;
      replace = [];
      for (i = 0; i < search.length; i += 1) {
        replace[i] = temp;
      }
    }
    temp = '';
    f = [].concat(search);
    r = [].concat(replace);
    ra = Object.prototype.toString.call(r) === '[object Array]';
    s = subject;
    // sa = Object.prototype.toString.call(s) === '[object Array]'
    s = [].concat(s);
    os = [].concat(os);
    if (countObj) {
      countObj.value = 0;
    }
    for (i = 0, sl = s.length; i < sl; i++) {
      if (s[i] === '') {
        continue;
      }
      for (j = 0, fl = f.length; j < fl; j++) {
        temp = s[i] + '';
        repl = ra ? (r[j] !== undefined ? r[j] : '') : r[0];
        s[i] = (temp).split(f[j]).join(repl);
        otemp = os[i] + '';
        oi = temp.indexOf(f[j]);
        ofjl = f[j].length;
        if (oi >= 0) {
          os[i] = (otemp).split(otemp.substr(oi, ofjl)).join(repl);
        }
        if (countObj) {
          countObj.value += ((temp.split(f[j])).length - 1);
        }
      }
    }
    return osa ? os : os[0];
}


export default function translit(str: string) {
  const dictionaries: any = store.state.options.translitdict;
  const latinKeys = keys(dictionaries.latin);
  const latinVals = values(dictionaries.latin);
  const cyrillicKeys = keys(dictionaries.cyrillic);
  const cyrillicVals = values(dictionaries.cyrillic);

  str = str_ireplace(cyrillicKeys, cyrillicVals, str);
  str = str_ireplace(latinKeys, latinVals, str);
  str = str_ireplace(',', '', str);
  return str;
}
